import { useEffect, useState } from "react";
import { ListGroup, ListGroupItem } from "reactstrap";
import { useHotkeys } from "react-hotkeys-hook";
import { CyResultList } from "./CyResultList";
import { FuseResult } from "fuse.js";
import { SearchEngineEntry } from "../search/SearchEngineEntry";
import { SongBadges } from "../common/components/song/SongBadges";
import { CyItems } from "../items/CyItems";

interface Props {
  entrySelected: (id: string) => void;
  searchResults: FuseResult<SearchEngineEntry>[];
  /** up, down and enter navigate the results only while enabled */
  keyboardNavigationEnabled: boolean;
}

export function ResultList({
  searchResults,
  entrySelected,
  keyboardNavigationEnabled,
}: Props) {
  useHotkeys("up", () => setSelectedItem((p) => Math.max(p - 1, 0)), {
    enableOnFormTags: ["input"],
    enabled: keyboardNavigationEnabled,
  });
  useHotkeys(
    "down",
    () => setSelectedItem((p) => Math.min(p + 1, searchResults.length - 1)),
    { enableOnFormTags: ["input"], enabled: keyboardNavigationEnabled },
  );

  useHotkeys(
    "enter",
    (e) => {
      e.preventDefault();
      const r = searchResults.at(selectedItem);
      if (r) {
        entrySelected(r.item.id);
      }
    },
    { enableOnFormTags: ["input"], enabled: keyboardNavigationEnabled },
  );

  const [selectedItem, setSelectedItem] = useState(0);

  useEffect(() => {
    setSelectedItem(0);
  }, [searchResults]);

  return (
    <ListGroup flush>
      {searchResults.map((result, index) => {
        return (
          <ListGroupItem
            key={result.item.id}
            tag="button"
            action
            onClick={() => entrySelected(result.item.id)}
            active={index === selectedItem}
            data-cy={CyResultList.ButtonResultEntry}
          >
            <span className="lead me-2" data-cy={CyItems.ItemTitle}>
              {result.item.title}
            </span>
            <small>{result.item.versionDescription}</small>
            <div className="float-md-end">
              <SongBadges badgeProvider={result.item} />
            </div>
          </ListGroupItem>
        );
      })}
    </ListGroup>
  );
}
